'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    // TODO refactor when aphrodite-jss keyframes bug will be fixed
    if (!Object.getPrototypeOf(this).__preloaderKeyframesSetted) {
        var doc = window.document,
            style = doc.createElement('style'),
            sheet = void 0;

        style.setAttribute('data-meta', 'p24c-preloader-jss');

        doc.querySelector('head').insertBefore(style, doc.querySelector('head').firstChild);
        sheet = Array.prototype.find.call(doc.styleSheets, function (s) {
            return s.ownerNode === style;
        });

        Object.getPrototypeOf(this).__preloaderKeyframesSetted = true;
        try {
            sheet.insertRule('@keyframes component-preloader-rotate ' + preloaderRotate, sheet.cssRules && sheet.cssRules.length);
            sheet.insertRule('@-webkit-keyframes component-preloader-rotate ' + preloaderRotate, sheet.cssRules && sheet.cssRules.length);
            sheet.insertRule('@keyframes component-preloader-dash ' + containerRotate, sheet.cssRules && sheet.cssRules.length);
            sheet.insertRule('@-webkit-keyframes component-preloader-dash ' + containerRotate, sheet.cssRules && sheet.cssRules.length);
        } catch (e) {
            window.console && window.console.log(e);
        }
    }

    if (this.props.small) {
        theme.width = theme.gutter * 3 + 'px';
        theme.height = theme.gutter * 3 + 'px';
    }

    if (this.props.xSmall) {
        theme.width = theme.tlNormal;
        theme.height = theme.tlNormal;
    }

    if (this.props.large) {
        theme.width = theme.gutter * 6 + 'px';
        theme.height = theme.gutter * 6 + 'px';
    }

    var position = {
        top: 'calc(50% - ' + (0, _pixelToNumber2.default)(theme.height) / 2 + 'px)',
        left: 'calc(50% - ' + (0, _pixelToNumber2.default)(theme.width) / 2 + 'px)'
    };

    var rootWidth = '100%';

    if (this.props.inline) {
        theme.display = 'inline-block';
        rootWidth = 'auto';
        theme.padding = 0;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            display: theme.display,
            width: rootWidth,
            position: 'relative',
            padding: theme.padding,
            textAlign: 'center',
            boxSizing: 'content-box',

            '&.center': Object.assign({
                width: 'auto',
                position: 'absolute'
            }, position)
        },
        wrapper: {
            height: theme.height
        },
        container: {
            animation: 'component-preloader-rotate 1.4s linear 0s infinite',
            zIndex: 2,
            width: theme.width,
            height: theme.height,
            margin: '0 auto'
        },
        containerPath: {
            animation: 'component-preloader-dash 1.4s ease-in-out 0s infinite',
            stroke: theme.circleColor,
            strokeDasharray: '80px, 200px',
            strokeDashoffset: 0,
            strokeLinecap: 'round',
            transform: 'translateZ(0)'
        },
        text: {
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            padding: theme.gutter + 'px 0',
            color: theme.color
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        text: (0, _aphroditeJss.css)(styleList.text),
        containerPath: (0, _aphroditeJss.css)(styleList.containerPath),
        container: (0, _aphroditeJss.css)(styleList.container),
        wrapper: (0, _aphroditeJss.css)(styleList.wrapper)
    };
};

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        display: 'block',
        circleColor: theme.elAccent,
        color: theme.tInactive,
        fontSize: theme.tsNormal,
        lineHeight: theme.tlNormal,
        padding: theme.gutter + 'px 0',
        height: theme.gutter * 4 + 'px',
        width: theme.gutter * 4 + 'px'
    };
};

var preloaderRotate = '\n    { \n        100% {\n            transform: rotate(360deg); \n        } \n    }\n';

var containerRotate = '\n    {\n        0% {\n            stroke-dasharray: 1px, 200px;\n            stroke-dashoffset: 0; \n        } \n        50% {\n            stroke-dasharray: 100px, 200px;\n            stroke-dashoffset: -15px;\n        } \n        100% {\n            stroke-dasharray: 100px, 200px;\n            stroke-dashoffset: -120px;\n        }\n    }\n';